module.exports = __webpack_public_path__ + "static/media/berthi.textile-collection-min.821653f4.png";